import { DEV_TOOLBOX_MOCK_ITEM_ID } from "@/lib/devToolbox/itemDetailMocks";
import { isDevToolboxEnabled } from "@/lib/devToolbox/isDevToolboxEnabled";
import { DEV_PAYMENT_SUCCESS_MOCK } from "@/lib/devToolbox/buyerTransactionMocks";

export function isDevToolboxPaymentSuccessMock(itemId: string): boolean {
  return isDevToolboxEnabled() && itemId === DEV_TOOLBOX_MOCK_ITEM_ID;
}

export function getDevToolboxPaymentSuccessMock() {
  return DEV_PAYMENT_SUCCESS_MOCK;
}
